import { type AccentHue, colorize } from "@repo/fika-design-system/color"
import type { IconName } from "@repo/fika-design-system/icon"
import type { ParentProps } from "solid-js"
import { Box } from "@/designSystem/components/box"
import { Icon } from "@/designSystem/components/icon"
import { Text } from "@/designSystem/components/text"
import { childrenClass, sectionRecipe, titleClass } from "./section.css"

type Props = ParentProps & {
  title: string
  description: string
  iconName: IconName
  hue: AccentHue
  direction?: "row" | "column"
}
export function Section(props: Props) {
  return (
    <Box class={sectionRecipe({ direction: props.direction || "row" })} fill>
      <Box class={titleClass}>
        <Icon
          name={props.iconName}
          color={colorize(props.hue, "700")}
          size="32"
        />
        <Box>
          <Text fontSize="h3" color="sand900" fontWeight="500">
            {props.title}
          </Text>
          <Text color="sand800" fontSize="s">
            {props.description}
          </Text>
        </Box>
      </Box>
      <Box class={childrenClass}>{props.children}</Box>
    </Box>
  )
}
